export const styles = {
  filterSearchWrapper: {
    margin: '0 65px 0 40px',
  },
  filterWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',

    '&>div': {
      paddingLeft: '30px',
    },
  },
  pagination: {
    margin: '0 40px',
  },
}
